<template>
  <div class="staff-dialog-container">
    <el-dialog
      class="staff-dialog"
      :visible.sync="dialogShow"
      destroy-on-close
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="staff-dialog-top">
        <p class="tit">{{ isEdit ? '员工详情' : '添加员工' }}</p>
        <i class="icon iconfont iconicon_close1 activeIconHover" @click="handleClose"></i>
      </div>

      <div class="staff-dialog-content">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
          <div class="tis-header">
            基本信息
          </div>
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="ruleForm.realname" placeholder="请输入姓名" maxlength="20" clearable></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱" clearable maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
          <div class="tis-header">
            工作信息
          </div>
          <el-form-item label="部门" prop="depart_id">
            <el-cascader
              ref="cascader"
              :props="props"
              v-model="ruleForm.depart_id"
              clearable
              @change="changeValue"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="职位" prop="job_id">
            <!-- <el-input v-model="ruleForm.job_id" placeholder="请输入岗位名称" clearable maxlength="50"></el-input> -->
            <el-select v-model="ruleForm.job_id" filterable remote clearable reserve-keyword placeholder="搜索：职位" :remote-method="remoteMethodJob" :loading="searchLevel">
              <el-option v-for="item in jobLevelList" :key="item.id" :label="item.job_name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="entry_time">
            <wf-date
              ref="inputLongText"
              v-model="ruleForm.entry_time"
              @change="changeTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </wf-date>
            <!-- <el-date-picker prefix-icon="icon iconfont iconicon_time1" v-model="ruleForm.entry_time" value-format="yyyy-MM-dd" :clearable="false" @change="changeTime" type="date" placeholder="选择日期"> </el-date-picker> -->
          </el-form-item>
          <el-form-item label="工号" prop="job_number">
            <el-input v-model="ruleForm.job_number" placeholder="请输入工号" maxlength="40" clearable></el-input>
          </el-form-item>
          <el-form-item label="用户类型" prop="usertype">
            <el-select v-model="ruleForm.usertype" placeholder="请选择" clearable>
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直接上级：" prop="leader_uid">
            <wf-select lazy :load="load" :props="{value: 'uid', label: 'realname'}" v-model="ruleForm.leader_uid" @change="leaderChange">
              <template>
                <el-input readonly v-model="leaderData.realname" placeholder="请选择">
                  <i class="icon iconfont iconicon_drop_down_arrow rota90" slot="suffix"></i>
                </el-input>
              </template>
              <div slot="item" slot-scope="{data}">
                <Myavatar width="28px" height="28px" :imgUrl="data.user_avatar" :userName="data.realname">
                  <span>{{data.realname}}</span>
                </Myavatar>
              </div>
            </wf-select>
            <!-- <el-select v-model="ruleForm.leader_uid" filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称" :remote-method="remoteMethod" :loading="searchLoading">
          <el-form-item label="直接上级" prop="leader_uid">
            <el-select v-model="ruleForm.leader_uid" filterable remote clearable reserve-keyword placeholder="搜索：姓名 / 邮箱 / 手机号 / 职称" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in leaderList" :key="item.uid" :label="item.realname" :value="item.uid"> </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="工作状态" prop="working_status">
            <el-select v-model="ruleForm.working_status" placeholder="请选择">
              <el-option v-for="item in statusList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信息状态" prop="is_secret">
            <el-select v-model="ruleForm.is_secret" placeholder="请选择">
              <el-option v-for="(item, index) in secretList" :key="item" :label="item" :value="index"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入备注" maxlength="120" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="staff-dialog-footer">
        <span class="cancel text-btn-active" @click="handleClose">取消</span>
        <wf-button type="primary" :disabled="btnDisabled" @click="handldeSubmit" :loading="btnLoading">保存</wf-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { isEmail, isMobile } from "@/utils/validate";
import apiLevel from "@/services/api/jobLevel/jobLevel";
import dayjs from "dayjs";
//api
import deparApi from "@/services/api/department/department";
import api from "@/services/api/staffManagement/staffManagement";

export default  {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dataset: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    // 保存按钮是否置灰
    btnDisabled() {
      return !this.ruleForm.realname || !this.ruleForm.email || this.ruleForm.depart_id.length === 0 || !this.ruleForm.job_id || !this.ruleForm.job_number
    }
  },
  watch: {
  },
  data() {
    const _this = this
    const isEmailFun = (rule, value, callback) => {
      if (!isEmail(value)) {
        callback(new Error("邮箱格式不正确"));
      } else {
        return callback();
      }
    };
    const isMobileFun = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        return callback();
      }
    };
    return {
      typeList: [
        { value: 0, label: "默认" },
        { value: 1, label: "普通员工" },
        { value: 2, label: "主管" },
        { value: 3, label: "经理" },
        { value: 4, label: "总监" },
        { value: 5, label: "总裁" },
        { value: 7, label: "CEO" },
        { value: 10, label: "管理员" },
      ],
      job_number_typeList: ["EH", "TY"],
      statusList: ["实习", "试用", "正式"],
      secretList: ["不保密", "保密"],
      leaderList: [],
      jobLevelList: [],
      ruleForm: {
        depart_id: "",
        realname: "",
        email: "",
        usertype: 1,
        phone: "",
        status: 1,
        job_number: "",
        job_id: "",
        leader_uid: "",
        working_status: "试用",
        is_secret: 0,
        entry_time: dayjs(new Date()).format("YYYY-MM-DD"),
        remark: "",
      },
      searchLoading: false,
      btnLoading: false,
      searchLevel: false,
      rules: {
        depart_id: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        realname: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        email: [
          { required: true, message: "此项不能为空", trigger: "blur" },
          { validator: isEmailFun, trigger: "blur" },
        ],
        // usertype: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '此项不能为空', trigger: 'blur' }, { validator: isMobileFun, trigger: 'blur' }],
        job_number: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        job_id: [{ required: true, message: "此项不能为空", trigger: "blur" }],
        // leader_uid: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // working_status: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
        // is_secret: [{ required: true, message: '此项不能为空', trigger: 'blur' }],
      },
      props: {
        lazy: true,
        value: "depart_id",
        label: "name",
        checkStrictly: true,
        emitPath: true,
        lazyLoad(node, resolve) {

          // console.log(node, 111)
          const { data } = node;
          deparApi.getDepartmentIndex({ pid: data ? data.depart_id : 0, level: 1 }).then((res) => {
            let tree = (dataset) => {
              dataset.map((item) => {
                if (item.children && item.children.data) {
                  item.children = item.children.data;
                } else {
                  return;
                }
                if (item.children && item.children.length > 0) {
                  tree(item.children);
                }
              });
            };
            tree(res.data);
            res.data.map((res) => {
              res.leaf = !(res.children_amount > 0);
            });
            resolve(res.data);
          });
        },
      },
      load: async (resolve, params) => {
        let result = await api.getStaffIndex({ ...params,  working_type: '在职' })
        resolve(result.data)
      },
      leaderData: {}
    }
  },
  created() {
    if (this.isEdit) {
      this.init()
    } else {
      // console.log(this.ruleForm, 111)
    }
    // console.log(this.departmentInfo, 111)

  },
  methods: {
    async getDepartmentFn(id) {
      let treeModel = []
      const param = {
        pid: id ? id : 0,
        level: 1
      }
      const res = await api.getDepartmentIndex(param)
      if (res) {
        const tree = (dataset) => {
          dataset.map(item => {
            if (item.children && item.children.data) {
              item.children = item.children.data
            } else {
              return
            }
            if (item.children && item.children.length > 0) {
              tree(item.children)
            }
          })
        }
        tree(res.data)
        res.data.map(item => {
          item.leaf = !(item.children_amount > 0)
        })
        treeModel = JSON.parse(JSON.stringify(res.data))
        return treeModel
      }
    },
    init () {
      let { depart_id, realname, email, usertype, phone, status, job_number, job_title, leader_uid, working_status, is_secret, department_tree, uid, remark, entry_time } = this.dataset;
      this.leaderList = [];
      // this.dataset.leader && this.remoteMethod(this.dataset.leader.realname);
      let depart_idArr = department_tree
        .split(",")
        .filter((res) => res)
        .map((res) => res * 1);
      this.ruleForm = { depart_id: [...depart_idArr], realname, email, usertype, phone, status, job_number, job_title, leader_uid: Boolean(leader_uid) ? leader_uid : "", working_status, is_secret, uid, job_id: this.dataset.job.id, remark, entry_time };
      this.leaderData = this.dataset.leader || {}
      this.remoteMethodJob(this.dataset.job.job_name);
    },
    async remoteMethod(keyword) {
      this.searchLoading = true;
      await api.getStaffIndex({ keyword }).then((res) => {
        this.leaderList = JSON.parse(JSON.stringify(res.data));
      });
      this.searchLoading = false;
    },
    async remoteMethodJob(keyword) {
      this.searchLevel = true;
      await apiLevel.getUserJobLevel({ keyword }).then((res) => {
        this.jobLevelList = JSON.parse(JSON.stringify(res.data));
      });
      this.searchLevel = false;
    },
    resetForm() {
      this.leaderList = [];
      this.jobLevelList = [];
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    },
    handleClose() {
      this.resetForm()
      this.$emit('handleClose')
    },
    handldeSubmit() {
      this.btnLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.depart_id = params.depart_id[params.depart_id.length - 1];

          if (this.isEdit) {
            api
              .updateStaff(params)
              .then((res) => {
                this.$emit("complete");
                this.$message({ message: "员工信息更新成功", type: "success" });
              })
              .catch((err) => {
                this.btnLoading = false;
              });
          } else {
            api
              .saveStaff(params)
              .then((res) => {
                this.$emit("complete");
                this.$message({ message: "员工新增成功", type: "success" });
                this.btnLoading = false;
              })
              .catch((err) => {
                this.btnLoading = false;
              });
          }

        } else {
          this.btnLoading = false;
          return false;
        }
      });
    },
    async changeValue(val) {
      const _id = val ? val[val.length - 1] : ''

      const _node = this.$refs.cascader.getCheckedNodes()[0]
      if (_node.data.children_amount && !_node.children.length) {
        // 父级有子集并且子集为空时，加载子集
        const param = {
          level: 1,
          pid: _node.data.depart_id
        }
        const res = await deparApi.getDepartmentIndex(param)
        let tree = (dataset) => {
          dataset.map((item) => {
            if (item.children && item.children.data) {
              item.children = item.children.data;
            } else {
              return;
            }
            if (item.children && item.children.length > 0) {
              tree(item.children);
            }
          });
        };
        tree(res.data);

        // 调用组件原生的插入节点方法插入子节点
        this.$refs.cascader.panel.store.appendNodes(res.data, _node)
      }

      this.ruleForm.departments_id = _id
    },
    changeTime(e) {},
    leaderChange(item) {
      console.log('-asd-', item)
      this.leaderData = item
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.staff-dialog-container {
  .staff-dialog {
    .el-dialog {
      width: 720px;
      margin-top: 2vh !important;
      .el-dialog__header {
        padding: 0 !important;
      }
      .el-dialog__body {
        padding: 0 !important;
        .staff-dialog-top {
          width: 100%;
          padding: 16px 24px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid  rgba(32, 32, 32, .08);
          .tit {
            font-size: 18px;
            line-height: 22px;
          }
        }
        .staff-dialog-content {
          .el-form {
            width: 100%;
            padding: 26px 24px 16px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .tis-header {
              width: 100%;
              font-size: 16px;
              font-weight: bold;
              line-height: 20px;
              margin-bottom: 24px;
              &:last-child {
                margin-top: 11px;
              }
            }
            .el-form-item {
              width: 320px;
              margin-bottom: 24px;
              &:last-child {
                width: 100%;
                margin-bottom: 0;
              }
            }
            .el-form-item__label {
              font-size: 14px;
              line-height: 20px;
              @include fontColorOpacity(.8);
              width: 100%;
              text-align: left;
            }
            .el-input {
              height: 40px;
              .el-input__inner {
                height: 40px;
                line-height: 40px;
              }
              .el-input__icon {
                line-height: 40px;
              }
            }
            .el-select,
            .el-cascader,
            .el-date-editor {
              width: 100%;
            }
            textarea {
              height: 98px !important;
            }
            .user-box {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              .user-item {
                padding: 0 8px;
                border-radius: 4px;
                border: 1px solid rgba(32,32,32,0.16);
                margin: 0 8px 8px 0;
                display: flex;
                &:hover {
                  i {
                    display: block;
                  }
                }
                i {
                  cursor: pointer;
                  font-size: 12px;
                  margin-left: 8px;
                  display: none;
                }
              }
              .add-btn {
                cursor: pointer;
                width: 42px;
                height: 40px;
                border-radius: 4px;
                border: 1px solid rgba(32, 32, 32, .16);
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }
        }
        .staff-dialog-footer {
          width: 100%;
          height: 64px;
          padding: 0 24px;
          box-sizing: border-box;
          border-top: 1px solid rgba(32, 32, 32, .08);
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .wf-button {
            width: 76px;
            margin-left: 24px;
          }
        }
      }
    }
  }
}
</style>
